import useSWR from 'swr'
import ServiceAPI from '~services/services'
// import { DateRangeType } from '~types/IDateRange'
import { QueryParams } from '~types/queryParams'

export const useFetchAccessLogs = (params: QueryParams, refreshInterval: number) => {
    const { data, mutate, error } = useSWR([`/logs/access-logs?limit=${params?.limit}&page=${params?.page}`, params], () => ServiceAPI.getAccessLogs(params), { refreshInterval });

    return {
        data,
        isLoading: !error && !data,
        isError: error,

        mutate,
    }
}

export default useFetchAccessLogs
